import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { ArtTextStyle } from "../../../lib/schedule-presets/art-metadata";
import { loadArtFont } from "../../../lib/schedule-art/art-fonts";

export function MissingFonts({ json }: { json: string }) {
  const { t } = useTranslation();
  const [missing, setMissing] = useState<string[]>([]);
  useEffect(() => {
    let disposed = false;
    setMissing([]);
    try {
      const metadata = JSON.parse(json);
      if (!metadata?.styles || typeof metadata.styles !== "object" || Array.isArray(metadata.styles)) return;
      const referenced = Object.values(metadata.styles).flatMap(style => {
        if (!style || typeof style !== "object" || !("font" in style) || typeof style.font !== "string") return [];
        return [{ font: style.font, weight: "weight" in style ? style.weight : 400 } as ArtTextStyle];
      });
      const fonts = referenced;
      Promise.all(fonts.map(loadArtFont)).then(results => {
        if (!disposed) setMissing([...new Set(fonts.filter((_, index) => !results[index]).map(style => `${style.font} (${style.weight ?? 400})`))].sort());
      });
    } catch { /* Incomplete JSON has no font list to check. */ }
    return () => { disposed = true; };
  }, [json]);
  if (!missing.length) return null;
  return (
    <div className="space-y-1 text-xs text-red-600" aria-live="polite">
      <p className="font-medium">{t("metadata.missingFonts")}</p>
      <ul className="list-disc space-y-1 pl-4">
        {missing.map(font => <li key={font} className="break-all font-mono">{font}</li>)}
      </ul>
    </div>
  );
}
